'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'bicycle';
var width = 640;
var height = 512;
var aliases = [128690];
var unicode = 'f206';
var svgPathData = ['M16 352c0-70.7 57.3-128 128-128 10.8 0 21.2 1.3 31.2 3.8l-26.2 52.3c-1.7-.1-3.4-.2-5.1-.2-39.8 0-72 32.2-72 72s32.2 72 72 72c34.3 0 62.9-23.9 70.2-56l56.8 0c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128zm352 0c0-42 20.2-79.2 51.4-102.6l25.3 52c-12.8 13-20.7 30.8-20.7 50.5 0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72c-2.7 0-5.5 .2-8.1 .5l-25.3-52c10.7-2.9 21.9-4.4 33.4-4.4 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128z', 'M313.6 32l166.4 0 0 48-89.6 0 127.2 261.5 10.5 21.6-43.2 21-10.5-21.6-75.4-154.9-73.6 147.2-6.6 13.3-213.7 0c.9-1.9 33.8-67.6 98.5-197.1l-11.5-26.9-64.2 0 0-48 95.8 0c2.8 6.5 9.7 22.5 20.6 48l123.7 0c-28.6-58.8-46.8-96.2-54.5-112zM228.5 228.7l-45.6 91.3 84.8 0-39.1-91.3zM305.7 287l47.5-95-88.2 0 40.7 95z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBicycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;